import { render, staticRenderFns } from "./SignFail.vue?vue&type=template&id=70ec6e6e&scoped=true&"
import script from "./SignFail.vue?vue&type=script&lang=js&"
export * from "./SignFail.vue?vue&type=script&lang=js&"
import style0 from "./SignFail.vue?vue&type=style&index=0&id=70ec6e6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec6e6e",
  null
  
)

export default component.exports